import { UploadError } from '../../errors';
import type { UploaderChunkState } from '../../state';

export class S3EmptyChunkEtagError extends UploadError {
  chunk: UploaderChunkState<unknown>;

  constructor(chunk: UploaderChunkState<unknown>) {
    super(`Chunk ${chunk.index} etag header is empty`);
    this.chunk = chunk;
  }
}

export class S3ChecksumsUnsupportedError extends UploadError {
  constructor() {
    super('MD5 checksums are not supported for this upload kind');
  }
}

export class S3EmptyUploadIdError extends UploadError {}

export class S3InvalidCompleteResponseError extends UploadError {
  constructor(message?: string) {
    super(message ?? 'Invalid complete response');
  }
}

export class S3MultipartUploadIdEmptyError extends UploadError {
  constructor() {
    super('Multipart upload ID is empty');
  }
}

export class S3UploadError extends UploadError {
  cause?: Error;

  code: string;

  constructor(code: string, message: string, cause?: Error) {
    super(message);
    this.cause = cause;
    this.code = code;
  }
}
